var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(-861 -613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M17,15.4H7.006a2,2,0,0,0-1.11.336L1,19V3A2,2,0,0,1,3,1H17a2,2,0,0,1,2,2V13.4A2,2,0,0,1,17,15.4Z",
    transform: "translate(861 613)",
    fill: "none",
    stroke: "#1f2659",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M8.65,5.5,5.95,8.2l2.7,2.7",
    transform: "translate(861 613)",
    fill: "none",
    stroke: "#1f2659",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x1: 7.65,
    transform: "translate(866.949 621.2)",
    fill: "none",
    stroke: "#1f2659",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowup);
export default __webpack_public_path__ + "static/media/followup.a0e2bac2e6408f0c0495c5aa68fa0289.svg";
export { ForwardRef as ReactComponent };